import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory } from 'react-router';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { PracticeManagement } from '~/types/api.model';
import APIKeyModal from '../APIKeyModal/APIKeyModal';
import { CardHandler } from '../APIKeyPM/APIKeyPM.utils';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import clientHubLogoUrl from './client-hub-logo.png';
const ClientHubCard = (param)=>{
    let { integration } = param;
    const { t: texts } = useLocaleKeys('integrations.availableApps.clientHub');
    const history = useHistory();
    const overlayContext = useOverlayContext();
    const { api, fetchIntegrations } = useStoreActions();
    const ui = {
        goToPage: (page)=>history.push(page),
        requestApiKey: (apiKeyListener)=>overlayContext.showModal({
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(APIKeyModal, {
                        pmName: PracticeManagement.ClientHub,
                        dismissModal: dismissModal,
                        apiKeyListener: apiKeyListener
                    });
                }
            }),
        refetchIntegrations: async ()=>fetchIntegrations()
    };
    const server = {
        saveApiKey: async (apiKey)=>api.clientHub.setAPIKey(apiKey)
    };
    const clientHubCardHandler = new CardHandler(ui, integration, server);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "client-hub-card",
        title: texts.title(),
        subTitle: texts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            testId: "client-hub-card-connect",
            onClick: ()=>clientHubCardHandler.handleClick(routes.clientHubSetup),
            children: clientHubCardHandler.getActionText()
        }),
        icon: /*#__PURE__*/ _jsx(IntegrationCard.LogoImg, {
            alt: "client hub logo",
            src: clientHubLogoUrl
        }),
        disclaimer: texts.disclaimer()
    });
};
export default ClientHubCard;
